import { useApolloClient } from '@apollo/client';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { useIntercom } from 'react-use-intercom';

import { useConfig } from '~/components/ConfigProvider';

import { INTERCOM_TOKEN_QUERY } from './IntercomTokenQuery.gql';

export const useIntercomWithUser = (): void => {
  const { i18n } = useTranslation();
  const config = useConfig();
  const intercom = useIntercom();
  const { user, isAuthenticated } = useAuth();
  const client = useApolloClient();
  const language = i18n.language;

  useEffect(() => {
    if (isAuthenticated) {
      (async () => {
        try {
          const { data, error } = await client.query({ query: INTERCOM_TOKEN_QUERY });
          if (error) {
            throw new Error(error.message);
          }
          intercom.boot({
            intercomUserJwt: data.tesseract.intercom.token,
            languageOverride: language,
            customAttributes: {
              Role: 'BUYER',
              'Customer key': config.intercom.customerKey,
            },
          });
        } catch (error) {
          console.error('Could not boot intercom properly', error);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useEffect(() => {
    if (user) {
      intercom.update({
        languageOverride: language,
      });
    }
  }, [language, user, intercom]);
};
